// extracted by mini-css-extract-plugin
export default {"status":"Status_status__s8l4X","icon":"Status_icon__+PL44"};